import { useRouter } from 'vue-router'
import usePut from './api/usePut'
import { ApiRequestStatus } from '../models/api/api-request-status'
import { useSnackStore } from '../../stores/snack.store'
import { useEventBus } from '@vueuse/core'
import { EventKey } from '../events/event-key'
import { OpenFeedbackState } from '../../modules/open-feedbacks/composables/useOpenFeedbacks'

export const useMutateFeedbackRequest = (input: {
  surveyId: string
  feedbackReceiverId: string
}) => {
  const router = useRouter()
  const { showInfo } = useSnackStore()
  const bus = useEventBus(EventKey.openFeedbackUpdated)

  const { mutate, status } = usePut<
    string,
    {
      surveyId: string
      feedbackReceiverId: string
      state: OpenFeedbackState
      rejectionReason?: string
    }
  >('feedback/updateFeedbackRequestState')

  const accept = async () => {
    await mutate({
      feedbackReceiverId: input.feedbackReceiverId,
      surveyId: input.surveyId,
      state: OpenFeedbackState.InProgress,
    })

    if (status.value == ApiRequestStatus.Success) {
      router.push({
        name: 'feedback',
        params: {
          surveyId: input.surveyId,
          receiverId: input.feedbackReceiverId,
        },
      })
      bus.emit({ surveyId: input.surveyId })
    }
  }

  const reject = async (rejectionReason?: string) => {
    await mutate({
      feedbackReceiverId: input.feedbackReceiverId,
      surveyId: input.surveyId,
      state: OpenFeedbackState.Rejected,
      rejectionReason: rejectionReason,
    })

    if (status.value == ApiRequestStatus.Success) {
      router.replace({
        name: 'dashboard',
      })

      bus.emit({ surveyId: input.surveyId })
      showInfo('Anfrage abgehnt', {
        label: 'Rückgängig machen',
        callback: () => {
          undoReject()
        },
      })
    }
  }

  const undoReject = async () => {
    await mutate({
      feedbackReceiverId: input.feedbackReceiverId,
      surveyId: input.surveyId,
      state: OpenFeedbackState.Pending,
    })

    if (status.value == ApiRequestStatus.Success) {
      bus.emit({ surveyId: input.surveyId })
    }
  }

  return { accept, reject }
}
